<template>
  <div>
    <div v-if="isLoading">
      <Loader />
    </div>
    <div v-else>
      <KolahduzanPrint v-if="iSKolahduzan" />
      <Print v-else />
    </div>
  </div>
</template>

<script>
import Print from './Print.vue'
import KolahduzanPrint from './KolahduzanPrint.vue'
import IdpDataProvider from '../../../../services/idp'
import Loader from '../../../../components/common/loader.vue'

export default {
  components: {
    Print,
    KolahduzanPrint,
    Loader,
  },
  data() {
    return {
      iSKolahduzan: null,
      isLoading: true
    }
  },
  created() {
    IdpDataProvider.getPagePermisions({
      path: '/invoice/print',
    }).then(res => {
      this.iSKolahduzan = res.data.data.config.iSKolahduzan
      this.isLoading = false
    })
  },
}
</script>
